// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__sOFGn","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3Htvx"};